export default __webpack_public_path__ + "static/media/refpredictor-b.8eb73865.svg";